var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpansionExistingCustomeractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 168,
    viewBox: "0 0 160 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_500_4204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.5684 92.9971C58.2489 92.9971 79.067 72.179 79.067 46.4986C79.067 20.8181 58.2489 0 32.5684 0C6.88795 0 -13.9302 20.8181 -13.9302 46.4986C-13.9302 72.179 6.88795 92.9971 32.5684 92.9971Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M103.213 174.28V181.798C103.213 184.577 101.079 186.832 98.4559 186.832H-35.2425C-37.8743 186.832 -40 184.577 -40 181.798V121.984C-40 109.092 -30.1353 98.6473 -17.9608 98.6473H19.3724C19.8325 98.6473 20.2466 98.9325 20.4399 99.3835L31.1696 122.251C31.3536 122.628 31.8598 122.628 32.0346 122.251L42.7735 99.3835C42.9576 98.9325 43.3809 98.6473 43.841 98.6473H68.5396C64.4631 106.046 62.1349 114.558 62.1349 123.613C62.1349 148.541 79.7479 169.348 103.213 174.28Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.75 169.476C139.212 169.476 159.844 148.845 159.844 123.392C159.844 97.9295 139.212 77.2982 113.75 77.2982C97.499 77.2982 83.208 85.709 75.0089 98.4264C70.3618 105.613 67.6655 114.19 67.6655 123.392C67.6655 145.164 82.7571 163.412 103.057 168.225C106.489 169.044 110.069 169.476 113.75 169.476ZM130.32 98.6226C133.662 98.6226 136.469 100.922 137.246 104.023L137.467 104.244V125.31C137.467 129.252 134.269 132.449 130.328 132.449C126.387 132.449 123.189 129.252 123.189 125.31V122.991L101.176 145.004C98.3874 147.793 93.8736 147.793 91.0851 145.004C88.2965 142.216 88.2965 137.702 91.0851 134.913L113.098 112.9H110.779C106.838 112.9 103.64 109.703 103.64 105.761C103.64 101.82 106.838 98.6226 110.779 98.6226H130.32Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_500_4204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 186.832,
    fill: "white",
    transform: "translate(-40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpansionExistingCustomeractive);
export default __webpack_public_path__ + "static/media/ExpansionExistingCustomeractive.dd071597a75b00342b980beb1aa2b0cd.svg";
export { ForwardRef as ReactComponent };